import React, { useEffect, useRef, useState } from "react";
import { Box, Tooltip, Typography } from "@mui/material";

const EllipsisTooltipCell = ({
  text,
  onClick,
  sx = {},
  placement,
}) => {
  const textRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsOverflow(element.scrollWidth > element.clientWidth);
    }
  }, [text]);

  return (
    <Tooltip
      title={
        isOverflow ? (
          <Typography
            sx={{
              whiteSpace: "normal",
              fontSize: "13px",
              lineHeight: "18px",
            }}
          >
            {text || "-"}
          </Typography>
        ) : ""
      }
      disableHoverListener={!isOverflow}
      arrow
      placement={placement}
      slotProps={{
        tooltip: { sx: { px: 1, py: 0.5 } },
      }}
    >
      <Box
        ref={textRef}
        onClick={onClick}
        sx={{
          width: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          ...sx,
        }}
      >
        {text || "-"}
      </Box>
    </Tooltip>
  );
};

export default EllipsisTooltipCell;
